import styled from "styled-components";

export const WalletHistoryItemWrapper = styled.div<{
  isSelected: boolean;
}>`
  height: ${(p) => (!p.isSelected ? "50px" : "120px")};
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: #fff;
  border-radius: 8px;
  width: 100%;
  transition: height 0.3s ease-in-out;
  overflow: hidden;
  padding: 10px 10px 17px;
  box-sizing: border-box;
  justify-content: space-between;
  paddin: 5px 10px 17px;
`;

export const WalletHistoryItemMainWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const WalletHistoryItemBase = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;

  > .date {
    width: 55px;
    text-align: center;
    font-weight: 600;
    font-size: 10px;
    color: #121212;
  }
`;

export const WalletHistoryItemRank = styled.div`
  height: 20px;
  padding: 2px 10px;
  gap: 2px;
  border-radius: 8px;
  background: #ffd101;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 62px;
  font-size: 10px;
  font-weight: 600;

  > img {
    width: 9.5px;
  }

  > .rank {
    display: flex;
    align-items: center;
  }
`;

export const WalletHistoryItemPub = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;

  > .pub {
    font-weight: 600;
    font-size: 15px;
  }

  > .tournament {
    font-weight: 400;
    font-size: 10px;
    color: #808080;
  }
`;

export const WalletHistoryItemInfoWrapper = styled.div<{
  isSelected: boolean;
}>`
  opacity: ${(p) => (p.isSelected ? 1 : 0)};
  width: 100%;
  height: 50px;
  border-radius: 8px;
  background: #6436e7;
  display: flex;
  padding: 10px;
  transition: opacity 0.2s ease-in-out;

  > div:not(:last-child) {
    border-right: 0.5px solid #ffffff80;
  }
`;

export const WalletHistoryInfoItem = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;

  > .name {
    font-size: 10px;
    font-weight: 400;
    text-align: center;
    color: #fff;
  }

  > .value {
    font-size: 11px;
    font-weight: 700;
    text-align: center;
    color: #fff;
  }
`;
